// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1_xtb","label":"Labeled_label__RKfUw","divider":"Labeled_divider__2EwEK"};